export const filterFields = (fields, searchTerm) => {
  if (!searchTerm?.trim()) return fields;

  const searchLower = searchTerm.toLowerCase();

  return fields.filter(field => {
    const label = field[2] || "";
    return label.toLowerCase().includes(searchLower);
  });
};
